export default "__VITE_ASSET__58827105__"